import { render, staticRenderFns } from "./IconWidget.vue?vue&type=template&id=3d29cb0a&"
import script from "./IconWidget.vue?vue&type=script&lang=js&"
export * from "./IconWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d29cb0a')) {
      api.createRecord('3d29cb0a', component.options)
    } else {
      api.reload('3d29cb0a', component.options)
    }
    module.hot.accept("./IconWidget.vue?vue&type=template&id=3d29cb0a&", function () {
      api.rerender('3d29cb0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconWidget.vue"
export default component.exports